<div class="wrapper-input">
  @if (icon()) {
    <div class="icon">
      <i class="fal fa-{{ icon() }}"></i>
    </div>
  }
  <input
    #input
    [type]="'string'"
    [placeholder]="placeholder() | translate"
    [value]="currentValue()"
    (blur)="onBlur($event)"
    (keyup)="onKeyUp($event)"
  />
  @if (displayClearIcon()) {
    <div class="icon" (click)="clear()">
      <i class="fal fa-times"></i>
    </div>
  }
</div>
